import { alpha, Box, CircularProgress } from "@mui/material";
import { styled } from "@mui/material/styles";

interface LoadingProps {
  opacity?: number;
  state?: boolean;
}

const Loading = ({ opacity = 0.5, state = false }: LoadingProps) => {
  if (!state) return null;

  return (
    <LoadingWrapper opacity={opacity}>
      <CircularProgress size={60} thickness={4} />
    </LoadingWrapper>
  );
};

const LoadingWrapper = styled(Box)<{ opacity: number }>(({ theme, opacity }) => ({
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: alpha(theme.palette.common.firstColor, opacity),
  zIndex: theme.zIndex.modal + 1,

  '.MuiCircularProgress-root': {
    color: theme.palette.common.thirdColor,
  }
}));

export { Loading };